import { Dialog } from "primereact/dialog";
import { Chips } from "primereact/chips";
import { Button } from "primereact/button";
import { useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import Loader from "../Loader/Loader";

export const ReusableDialog = ({
  visible,
  onHide,
  header,
  ejecutar = () => {},
  obtenerEnlace = () =>{},
  Id,
  enlace,
  correoAEnviar,
  setCorreoAEnviar,
  idioma,
  setIdioma,
  setLoading,
  loading
}) => {
    const [copied, setCopied] = useState(false);

    const copiarEnlace = () => {
      if (enlace) {
        navigator.clipboard.writeText(enlace);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    };

    const changeIdioma = (e) => {
        setIdioma(e.value);
        obtenerEnlace(Id, e.value);
    };

    return (
        <Dialog header={header} visible={visible} onHide={onHide} style={{ width: '50%' }}>
            <Loader loading={loading}/>
            <div>
                {/* Campo de Correo */}
                <div className="d-flex align-items-center mb-4">
                    <span className="mx-2 h5">Correo:</span>
                    <Chips 
                        style={{ flex: 1 }} 
                        className="col-12" 
                        value={correoAEnviar} 
                        onChange={(e) => setCorreoAEnviar(e.target.value)} 
                    />
                </div>

                {/* Selección de Idioma */}
                <div className="d-flex align-items-center mx-2 mb-4 mt-2">
                    <div className="d-flex p-ai-center">

                        <div className="d-flex gap-2">
                            <p>English</p>
                            <RadioButton
                                inputId="english"
                                name="idioma"
                                value="en"
                                checked={idioma === "en"}
                                onChange={(e) => changeIdioma(e)}
                                label="English"
                                style={{ marginRight: '10px' }}
                            />
                        </div>

                        <div className="d-flex gap-2">
                            <p>Español</p>
                            <RadioButton
                                inputId="spanish"
                                name="idioma"
                                value="es"
                                checked={idioma === "es"}
                                onChange={(e) => changeIdioma(e)}
                                label="Español"
                            />
                        </div>
                    </div>
                </div>


                {/* Enlace de Inscripción */}
                <div className="mb-2">
                    <p className="mx-2" style={{ wordWrap: 'break-word' }}>
                        Enlace de inscripción: {" "}
                        <a target="_blank" href={enlace}>
                            {enlace}
                        </a>
                    </p>
                </div>

                {/* Botones de Copiar y Navegar */}
                <div className="d-flex align-items-center mb-4">
                    <Button 
                        icon="pi pi-copy" 
                        className="p-button-secondary m-2" 
                        onClick={copiarEnlace} 
                        disabled={!enlace} 
                        tooltip={copied ? "Copiado" : "Copiar"} 
                        tooltipOptions={{ position: 'top' }} 
                    />
                    <Button 
                        icon="pi pi-external-link" 
                        className="p-button-secondary m-2" 
                        onClick={() => window.open(enlace, '_blank')} 
                        disabled={!enlace} 
                        tooltip="Navegar al enlace" 
                        tooltipOptions={{ position: 'top' }} 
                    />
                </div>

                {/* Botones de Acción (Cancelar y Enviar) */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Cancelar"
                        className="p-button-secondary m-2"
                        style={{ width: 100 }}
                        onClick={onHide}
                    />
                    <Button
                        label="Enviar"
                        style={{ width: 100 }}
                        className="p-button-success m-2"
                        onClick={() => ejecutar()}
                    />
                </div>
            </div>
        </Dialog>

    );
};

export default ReusableDialog;
